import React, { ElementType } from "react";
import {
    createStyles,
    IconButton,
    Theme,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";

type EditButtonProps = WithStyles<typeof styles> & {
    component: ElementType<unknown>;
};

const styles = (theme: Theme) =>
    createStyles({
        editButton: {
            marginLeft: theme.spacing(1.5),
            padding: theme.spacing()
        }
    });

class EditButton extends React.PureComponent<EditButtonProps, {}> {
    public render() {
        const { classes, component } = this.props;
        return (
            <IconButton className={classes.editButton} component={component}>
                <Edit fontSize="small" />
            </IconButton>
        );
    }
}

export default withStyles(styles)(EditButton);
